<template>
  <div>
    <div class="row">
      <div class="col-xl" style="padding:0">
        <company-edit-card :title="companyTitle" :company="companyProfile"></company-edit-card>
      </div>
    </div>
    <div class="row">
      <div class="col-xl" style="padding:0">
        <portfolio-edit-card :title="portfolioTitle" :portfolio="portfolioInfo"></portfolio-edit-card>
      </div>
    </div>
    <div class="row">
      <!-- save/cancel buttons -->
      <div class="col-xl edit-company-action-button-row">
        <button type="submit" class="todo-form-cancel-button btn-outline-secondary" @click.prevent="cancel">Cancel</button>
        <button
          type="submit"
          class="btn btn-info btn-fill btn-wd btn-success"
          @click.prevent="createCompany"
          :disabled="isSaving"
        >
          Create Company
          <i class="nc-icon nc-refresh-02 spinner"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import CompanyEditCard from "../../../components/Cards/Company/CompanyEditCard.vue";
import PortfolioEditCard from "../../../components/Cards/Portfolio/PortfolioEditCard.vue";
import { Company } from "../../../models/Company";
import { Portfolio } from "../../../models/Portfolio";
import { vals } from "../../../util";
import swal from "sweetalert2";
import api from "../../../axios_api";

const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";

export default {
  components: {
    CompanyEditCard,
    PortfolioEditCard
  },
  data() {
    return {
      isSaving: false,
      companyProfile: new Company({}),
      portfolioInfo: {},
      companyTitle: "New Company",
      portfolioTitle: "Your Portfolio Information"
    };
  },
  methods: {
    cancel() {
      // just cancel and go back one
      this.$router.go(-1);
    },
    createCompany() {
      this.isSaving = true;
      let portfolioInfo = _.cloneDeep(this.portfolioInfo);
      let companyProfile = _.cloneDeep(this.companyProfile);
      // parse out any numerical fields
      portfolioInfo.value = parseFloat(portfolioInfo.value);
      portfolioInfo.cost = parseFloat(portfolioInfo.cost);
      portfolioInfo.ownership = parseFloat(portfolioInfo.ownership);
      // save company name in portfolio info
      portfolioInfo.company_name = companyProfile.name;
      // run the context map for portfolio info
      if (
        !_.isNil(portfolioInfo.context) &&
        !_.isEmpty(portfolioInfo.context)
      ) {
        if (_.has(vals.PORTFOLIO.CONTEXT_MAP, portfolioInfo.context)) {
          portfolioInfo.context =
            vals.PORTFOLIO.CONTEXT_MAP[portfolioInfo.context];
        }
      }
      if (
        !_.isNil(portfolioInfo.direct_lp) &&
        !_.isEmpty(portfolioInfo.direct_lp)
      ) {
        portfolioInfo.direct_lp = portfolioInfo.direct_lp.toLowerCase();
      }

      let companyWriteResponse = null;
      // use the Company&Portfolio models to do any validations
      companyProfile = { ...companyProfile, ...portfolioInfo };
      let company = new Company(companyProfile);
      let portfolio = new Portfolio(portfolioInfo);
      let createdCompany = false,
        createdPortfolio = false;
      return (
        company
          .validate()
          // .then(res => {
          //   // check portfolio info
          //   return portfolio.validate();
          // })
          .then(res => {
            // validated portfolio info, write data...
            // lets try creating a company...
            return company.writeToServer();
          })
          .then(res => {
            companyWriteResponse = res;
            // set our portfolio company id to the company instance
            createdCompany = true;
            portfolio.company = company._id;
            portfolio.org_company_id = company._id;
            // write our portfolio
            //return portfolio.writeToServer();
          })
          .then(res => {
            // mark as retrieving

            if (
              !companyWriteResponse ||
              companyWriteResponse.data_status == DATA_STATUS_UNCONFIRMED
            ) {
              let url = `${this.$route.params.account_id}/${this.$route.params.workspace_id}/company/confirm`;

              return api.post(url, {
                encrypt: {
                  data: {
                    company: portfolio,
                    confirmedCompany: companyProfile.cb_data
                  }
                }
              });
            } else {
              return Promise.resolve(this);
            }
          })
          .then(res => {
            // need to reload our portfolio info
            return this.$store.dispatch("portfolio/_apiFetchPortfolio");
            return this.$store.dispatch("offering/getOfferings");
          })
          .then(res => {
            // done, show swal and go back
            swal({
              title: "Successfully Created Company",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success btn-fill"
            });
            this.isSaving = false;
            this.$router.go(-1);
          })
          .catch(err => {
            this.isSaving = false;
            console.log(`err: ${JSON.stringify(err)}`);
            if (!_.isNil(err.errors) && !_.isNil(err.type)) {
              // validation errors, create html for swal
              let html = "";
              html += `<p>There were validation errors with your ${err.type} information:</p>`;
              _.each(err.errors, e => {
                html += `${e}<br />`;
              });
              html += "</p>";
              swal({
                title: `${_.startCase(err.typ)} Validation Errors`,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                html
              });
            } else if (!_.isNil(err.errors)) {
              // proba list of errors from the server
              let html = "";
              html += `<p>Errors creating your ${
                !createdCompany ? "company" : "portfolio"
              }`;
              _.forIn(err.errors, (v, k) => {
                html += `${k}: ${v.message}<br />`;
              });
              html += "</p>";
              swal({
                title: `Server Validation Errors`,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                html
              });
            } else {
              console.log(`error: ${JSON.stringify(err)}`);
              // error (prob from the server)
              let text = !_.isNil(err.error) ? err.error : "";
              swal({
                title: `Unable to Create Company`,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                text
              });
            }
          })
      );
    }
  }
};
</script>
<style>
.edit-company-action-button-row {
  display: flex;
  justify-content: flex-end;
}

.edit-company-action-button-row button:first-child {
  margin-right: 10px;
}
</style>